// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

import Rails from '@rails/ujs'
import 'turbolinks'
import "cocoon-js-vanilla"

// These paths need to be added to config/vite.json
import.meta.glob('../images/*', { eager: true })
import.meta.glob('../css/*', { eager: true })

import "../channels/consumer.js"

import { start as progressStart } from "./utils/progress"
progressStart()

import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"

const application = Application.start()
const controllers = import.meta.glob('./**/*_controller.js', { eager: true })
registerControllers(application, controllers)

Rails.start()

import LocalTime from "local-time"
LocalTime.start()
